import { useFormContext, useWatch } from 'react-hook-form'
import { Box } from '@mui/material'

import { Button } from '@components/shared/Button'
import { CloseIcon } from '@assets/svgs/CloseIcon'
import { FilterIcon } from '@assets/svgs/FilterIcon'
import { RowBox } from '@components/shared/RowBox'
import { MultiSelect } from '@components/shared/MultiSelect'

import type { BigNumbersFiltersProps } from './types'

import * as S from './styles'

export const BigNumbersFilters = ({
  bigNumbersFiltersData,
  bigNumbersFiltersLoading,
  onConsolidatedPreviewFilters,
  getInitialBigNumbersFilters,
  onClearConsolidatedPreviewFilters
}: BigNumbersFiltersProps) => {
  const { control, reset } = useFormContext()

  const consolidatedPreviewFiltersFormValues = useWatch({ control, name: 'consolidatedPreviewFilters' })

  const handleResetFilters = () => {
    reset({
      bigNumbersFilters: getInitialBigNumbersFilters(),
      consolidatedPreviewFilters: consolidatedPreviewFiltersFormValues
    })
  }

  return (
    <RowBox columns={4} marginTop={32} marginBottom={16}>
      <MultiSelect
        name="bigNumbersFilters.businessUnit"
        label="Business Unit"
        placeholder="Selecione..."
        options={
          bigNumbersFiltersData?.businessUnit.map((item) => ({
            label: item.name,
            value: item.code
          })) || []
        }
        loading={bigNumbersFiltersLoading}
      />
      <MultiSelect
        name="bigNumbersFilters.directorate"
        label="Diretoria"
        placeholder="Selecione..."
        options={
          bigNumbersFiltersData?.boardOfDirectors.map((item) => ({
            label: item.name,
            value: item.code
          })) || []
        }
        loading={bigNumbersFiltersLoading}
      />
      <MultiSelect
        name="bigNumbersFilters.portfolio"
        label="Portfólio"
        placeholder="Selecione..."
        options={
          bigNumbersFiltersData?.portfolio.map((item) => ({
            label: item.name,
            value: item.code
          })) || []
        }
        loading={bigNumbersFiltersLoading}
      />
      <MultiSelect
        name="bigNumbersFilters.economicGroup"
        label="Grupo Econômico"
        placeholder="Selecione..."
        options={
          bigNumbersFiltersData?.economicGroup.map((item) => ({
            label: item.name,
            value: item.code
          })) || []
        }
        loading={bigNumbersFiltersLoading}
      />
      <MultiSelect
        name="bigNumbersFilters.product"
        label="Produto"
        placeholder="Selecione..."
        options={
          bigNumbersFiltersData?.product.map((item) => ({
            label: item.name,
            value: item.code
          })) || []
        }
        loading={bigNumbersFiltersLoading}
      />
      <MultiSelect
        name="bigNumbersFilters.serviceType"
        label="Tipo de Serviço"
        placeholder="Selecione..."
        options={
          bigNumbersFiltersData?.serviceType.map((item) => ({
            label: item.name,
            value: item.code
          })) || []
        }
        loading={bigNumbersFiltersLoading}
      />

      <Box />

      <S.FilterButtons>
        <Button
          width="100%"
          colorType="outlineBlue"
          rightIcon={<FilterIcon />}
          onClick={onConsolidatedPreviewFilters}
          disabled={bigNumbersFiltersLoading}
        >
          Filtrar
        </Button>

        <Button
          width="100%"
          colorType="outlineBlue"
          rightIcon={<CloseIcon />}
          onClick={() => {
            if (bigNumbersFiltersData) {
              handleResetFilters()
            } else {
              reset()
            }
            onClearConsolidatedPreviewFilters()
          }}
          disabled={bigNumbersFiltersLoading}
        >
          Limpar
        </Button>
      </S.FilterButtons>
    </RowBox>
  )
}
